import { contextPath } from "./ocm-object";

type UseRequestSettings = {
	url: string;
};

export default function ocmRequestSettings(searchQuery = ""): UseRequestSettings {
	const searchEncoded = encodeURIComponent(searchQuery);
	const url = `${contextPath}/rest/search/classic/autocomplete/?searchString=${searchEncoded}`;
	return { url };
}
